import React from 'react';
import { List, ListItem } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

function NavMenuItem({ menu }) {
  if (!menu || !Array.isArray(menu.child_routes) || menu.child_routes.length === 0) {
    return null;
  }

  // Preserve the existing rule: Manage Subcompanies is only available while
  // the SuperUser is in the parent-company context.
  const parentCompanyId = localStorage.getItem('companyId');
  const selectedCompanyId = localStorage.getItem('selectedCompanyId');
  const isSubCompanySession = Boolean(parentCompanyId && selectedCompanyId && selectedCompanyId !== parentCompanyId);
  const items = menu.child_routes.filter((item) => !(
    item.path === '/app/dashboard/subcompanies-management' && isSubCompanySession
  ));

  if (items.length === 0) return null;

  return (
    <section className="hr-main-nav-group" aria-label={menu.menu_title}>
      <div className="hr-main-nav-heading">{menu.menu_title}</div>
      <List className="hr-main-nav-list" disablePadding>
        {items.map((item) => (
          <ListItem className="hr-main-nav-list-item" component="li" disableGutters key={item.path || item.menu_title}>
            {item.path ? (
              <NavLink
                to={item.path}
                activeClassName="hr-main-nav-link-active"
                className={`hr-main-nav-link${item.new_item ? ' hr-main-nav-link-soon' : ''}`}
                title={item.new_item ? `${item.menu_title} — Coming Soon` : item.menu_title}
              >
                <i className={`hr-main-nav-icon ${item.menu_icon || 'zmdi zmdi-dot-circle'}`} aria-hidden="true" />
                <span className="hr-main-nav-label">{item.menu_title}</span>
                {item.new_item && <span className="hr-main-nav-badge">Coming Soon</span>}
              </NavLink>
            ) : (
              <span className="hr-main-nav-link hr-main-nav-link-disabled" aria-disabled="true">
                <i className={`hr-main-nav-icon ${item.menu_icon || 'zmdi zmdi-dot-circle'}`} aria-hidden="true" />
                <span className="hr-main-nav-label">{item.menu_title}</span>
                {item.new_item && <span className="hr-main-nav-badge">Coming Soon</span>}
              </span>
            )}
          </ListItem>
        ))}
      </List>
    </section>
  );
}

export default NavMenuItem;
